export const getRandomNumber = () => parseInt(Math.random().toString().substr(2, 10), 10);
